import React, { HTMLAttributes } from 'react'
import { useMatch, useNavigate, useResolvedPath } from 'react-router'
import { isGlobalSideNavCollapsed } from '../../Utils/isGlobalSideNavCollapsed'
import styles from './MenuItem.module.scss'

interface MenuItemProps extends React.LiHTMLAttributes<HTMLLIElement> {
  subMenuItem?: boolean
  icon?: React.ReactNode
  to?: string | undefined
  theme?: 'light' | 'dark'
  selected?: boolean
  disabled?: boolean
  titleProps?: HTMLAttributes<HTMLElement>
  onOpen?: () => unknown
}

const MenuItem: React.FC<MenuItemProps> = ({
  children = null,
  icon,
  selected = false,
  style = {},
  subMenuItem,
  to,
  theme = 'light',
  disabled = false,
  titleProps = { style },
  onOpen = () => {},
  ...props
}) => {
  const navigate = useNavigate()

  const resolved = useResolvedPath(to as string)
  const match: any = useMatch({ path: resolved.pathname, end: true })

  const handleNavigate = () => {
    if (to) {
      onOpen()
      navigate(to, { replace: true })
    }
  }

  const collapsed = isGlobalSideNavCollapsed()

  return (
    <li
      className={[styles['menu-item'], theme === 'dark' ? styles['menu-item__dark'] : ''].join(' ')}
      data-selected={match || selected ? 'true' : 'false'}
      style={{
        pointerEvents: disabled ? 'none' : 'all',
        cursor: 'pointer',
        ...style,
      }}
      title={collapsed && !subMenuItem ? `${children}` : ''}
      onClick={handleNavigate}
      {...props}
    >
      <a
        onClick={(e) => {
          e.preventDefault()
        }}
        style={{
          color: 'inherit',
          textDecoration: 'none',
        }}
      >
        <div
          className={[styles['menu-item__title']].join(' ')}
          {...titleProps}
          style={{
            display: 'flex',
            justifyContent: collapsed && !subMenuItem ? 'center' : 'start',
            padding: collapsed && !subMenuItem ? 0 : '0 16px 0 12px',
            lineHeight: '40px',
            ...titleProps?.style,
          }}
        >
          {icon ? <span>{icon}</span> : null}
          {collapsed && !subMenuItem ? null : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'middle',
                marginLeft: subMenuItem ? '24px' : '8px',
                flexGrow: 1,
              }}
            >
              {children}
            </div>
          )}
        </div>
      </a>
    </li>
  )
}

export default MenuItem
